import { createFileRoute } from "@tanstack/react-router"
import { organizationDocumentsViewLayoutHandle } from "src/views/OrganizationDocumentsView/constants"
import { OrganizationDocumentsView } from "src/views/OrganizationDocumentsView/OrganizationDocumentsView"

export const Route = createFileRoute("/_loggedIn/$organizationId/_map/_layout/documents/")({
	component: OrganizationDocumentsView,
	staticData: organizationDocumentsViewLayoutHandle,
})
